import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_CATEGORIES_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/categories`;

export const ADMIN_CATEGORIES_API_PATHS = {
  GET_CATEGORIES: `${ADMIN_CATEGORIES_API_ROOT}`,
  CREATE_CATEGORY: `${ADMIN_CATEGORIES_API_ROOT}`,
  UPDATE_CATEGORY: (categoryId: string) => `${ADMIN_CATEGORIES_API_ROOT}/${categoryId}`,
  ARCHIVE_CATEGORY: (categoryId: string) => `${ADMIN_CATEGORIES_API_ROOT}/${categoryId}`,
  RESTORE_CATEGORY: (categoryId: string) => `${ADMIN_CATEGORIES_API_ROOT}/${categoryId}/restore`,
  UPDATE_POSITIONS: `${ADMIN_CATEGORIES_API_ROOT}/positions`,
};
